<template>
  <div class="login">
    <div class="mylogin" align="center">
        <div class="logo-h2">
            <img src="../assets/login.png" alt="" style="z-index: 100">
            <span style="padding: 5px 0 5px 15px">{{ $t('login.title') }}</span>
        </div>
        <!-- <div class="logo-h1">登录</div> -->
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px">
            <el-form-item label="" prop="account" style="margin-top: 10px">
                <el-row>
                    <el-col :span="2">
                        <span class="el-icon-s-custom"></span>
                    </el-col>
                    <el-col :span="22">
                        <el-input class="inps" :placeholder="`${$t('login.account')}`" v-model="loginForm.account"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="" prop="passWord">
                <el-row>
                    <el-col :span="2">
                        <span class="el-icon-lock"></span>
                    </el-col>
                    <el-col :span="22">
                        <el-input class="inps" type="password" :placeholder="`${$t('login.password')}`" v-model="loginForm.passWord"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item style="margin-top: 55px">
                <el-button type="primary" class="submitBtn" @click="login">{{ $t('login.login') }}</el-button>
            </el-form-item>
        </el-form>
        <div @click="languageListShow()"
            class="header-lang">
            {{ getLanguageLabel }}
            <i class="el-icon-arrow-down"></i>
        </div>
        <div class="language_list"
            v-if="languageShow">
            <span v-for="item in languageList" :key="item.value" @click="setLanguage(item.value)">{{ item.label }}</span>
        </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'login',
        data() {
            return {
                languageShow: false,
                currentLanguage: 'zh',
                languageList: [{
                    value: 'zh',
                    label: '中文'
                }, {
                    value: 'en',
                    label: 'English'
                }],
                loginForm: {
                    account: "",
                    passWord: "",
                },
                loginRules: {
                    account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                    passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
                },
                firstLogin: false
            };
        },
        mounted() {
            if (localStorage.getItem('lang')) {
                this.currentLanguage = localStorage.getItem('lang');
            } else {
                localStorage.setItem('lang', 'zh');
            }
            document.addEventListener('click', this.hideMenu);
        },
        computed: {
            getLanguageLabel() {
                const i = this.languageList.findIndex(item => item.value === this.currentLanguage);
                if (i === -1) {
                    return '语言'
                }
                return this.languageList[i].label;
            }
        },
        methods: {
            async login() {
                await axios.get(`/customer/wechat/customer/login/${this.loginForm.account}/${this.loginForm.passWord}`)
                .then(response => {
                    if (response.data.code === 200) {
                        localStorage.setItem('token', response.data.data.token);
                        localStorage.setItem('scmAccount', response.data.data.account);
                        this.firstLogin = response.data.data.firstLogin;
                        this.getUserInfo();
                    } else {
                        this.$message.error(response.data.msg)
                    }
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            async getUserInfo() {
                const { code, data } = await this.qGet('/user/currentUser');
                if (code === 200) {
                    localStorage.setItem('user', JSON.stringify(data));
                    localStorage.setItem("tokenId", data.id);
                    if (this.firstLogin) {
                        this.$router.push('/change-password');
                        this.$message.warning(this.$t('changePassword.firstLoginMsg'));
                    } else {
                        this.$router.push('/goods');
                    }
                }
            },
            hideMenu(event) {
                // 检查点击目标是否是下拉框或触发元素
                if (!this.$el.contains(event.target)) {
                    this.languageShow = false;
                }
            },
            languageListShow() {
                this.languageShow = !this.languageShow;
            },
            setLanguage(e) {
                if (localStorage.getItem('lang') !== e) {
                    this.currentLanguage = e;
                    localStorage.setItem('lang', e);
                    this.$store.dispatch('switchLanguage', e)
                }
                this.languageShow = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login {
        width: 100vw;
        padding: 0;
        margin: 0;
        height: 100vh;
        font-size: 16px;
        background: linear-gradient(315deg,#FFFFFF 0%,#E8EFFC 100%);
        font-family: "Source Sans Pro";
        position: relative;
    }
    
    .mylogin {
        width: 300px;
        height: 400px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-color: #fff;
        box-shadow: 0 0 5px 1px rgb(223, 223, 223);
        padding: 50px 40px 40px 40px;
        opacity: 1;
    }
    
    .inps input {
        border: none;
        background-color: transparent;
        font-size: 12px;
    }
    
    .submitBtn {
        height: 66px;
        width: 82%;
        background: linear-gradient(115deg, #489be9, #3a79e6);
        border-radius: 6px;
        font-size: 26px;
        font-family: PingFangSCRegular;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 41px;
        text-shadow: 0 1px 2px rgba(255, 255, 255, 0.31);
        border: none;
        cursor: pointer;
    }
    .logo-h2 {
        margin: 20px 0 70px 10px;
        text-align: left;
        font-size: 26px;
        font-weight: 500;
        color: #009191;
        display: flex;
	    align-items: center;
        justify-content: center;
        /* line-height: 43px; */
    }
    .logo-h1 {
        font-size: 30px;
        margin-bottom: 50px;
        /* line-height: 30px; */
    }

    .header-lang {
        position: absolute;
        bottom: 10px;
        right: 15px;
        width: 80px;
        text-align: center;
        display: inline-block;
        font-size: 16px;
        line-height: 48px;
        color: #9fa9ba;
        cursor: pointer;
    }

    .language_list {
        background-color: #ffffff;
        position: absolute;
        right: 13px;
        bottom: -40px;
        font-size: 12px;
        box-shadow: 0 0 3px rgba(86, 96, 117, 0.3);
        cursor: pointer;
        z-index: 9999;
        span {
            display: block;
            margin: 2px;
            padding: 2px 15px;
            &:hover {
                background-color: #f5f5f5;
            }
        }
    }
</style>